//Affichage etoiles page produit
document.addEventListener('DOMContentLoaded', function () {
  const moveJudgeMe = () => {
    const stars = document.querySelector('.jdgm-preview-badge');
    const title = document.querySelector('.product-meta__title, h1.product__title, h1');

    if (stars && title && !stars.classList.contains('jm-moved')) {
      title.parentNode.insertBefore(stars, title);
      stars.classList.add('jm-moved');
    }
  };

  // essai immédiat
  moveJudgeMe();

  // retry car Judge.me charge en async
  let tries = 0;
  const interval = setInterval(() => {
    moveJudgeMe();
    tries++;
    if (tries > 20) clearInterval(interval);
  }, 300);
});

//fin affichage étoiles


